import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormLabel } from 'react-bootstrap';
import { Fields, reduxForm, change, stopAsyncValidation } from 'redux-form';
import { injectIntl, FormattedMessage } from 'react-intl';

import classNames from 'classnames';
import { connect } from 'react-redux';
import { InputBlock, scrollToFirstError, SharedMessages as sharedMessages } from 'ecs-react-components/dist/index.es';

import { messages } from './CreateAccountForm.i18n';
import TouModal from './TouModal';
import LoadingIndicatorContainer from '../../LoadingIndicatorContainer';
import { setIsDedicatedWorkflow } from '../../../redux/modules/workflow/workflow-action-creator';
import { loadTermsOfUse } from '../../../redux/modules/user-profile/user-profile-middleware';
import {
  loadPasswordRules,
  submitCreateAccount,
} from '../../../redux/modules/signup/create-account/create-account-middleware';
import * as MsgBarActions from '../../../redux/modules/system-shared/message-bar-action-creator';
import history from '../../../history';

const fields = ['email', 'username', 'password', 'confirmPassword', 'checkboxAccept'];
class CreateAccountForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
    };
  }

  UNSAFE_componentWillMount = () => {
    const formName = 'createaccountform';
    const { patient, dispatch, authorizedRepData } = this.props;

    dispatch(setIsDedicatedWorkflow(true));
    dispatch(loadPasswordRules());
    let email = null;
    if (authorizedRepData && authorizedRepData.email) {
      email = authorizedRepData.email;
    } else if (patient && patient.emailAddress) {
      email = patient.emailAddress;
    }
    if (!email) {
      return;
    }
    dispatch(change(formName, 'email', email));
    dispatch(change(formName, 'username', email));
  }

  componentWillUnmount = () => {
    this.props.dispatch(setIsDedicatedWorkflow(false));
  }

  onSubmit = (values, dispatch) => {
    const { patient, verifiedIdentityData, authorizedRepData } = this.props;
    let createAccountData = {};
    if (authorizedRepData.encryptedInvitationId) {
      createAccountData = {
        patientId: -1,
        emailAddress: authorizedRepData.email,
        username: values.username,
        password: values.password,
        isTermsOfUseAccepted: values.checkboxAccept,
        encryptedInvitationId: authorizedRepData.encryptedInvitationId,
      };
    } else {
      createAccountData = { patientId: patient.patientId,
        emailAddress: values.email,
        username: values.username,
        password: values.password,
        isTermsOfUseAccepted: values.checkboxAccept,
        ...verifiedIdentityData };
    }
    dispatch(submitCreateAccount(createAccountData, this.props.languageCode));
  }

  onClickCancel = (event) => {
    event.preventDefault();
    history.push('/login');
  }

  onEmailChange = (email, username) => (event) => {
    const { id, value } = event.target;
    if (id === email.input.name) {
      username.input.onChange(value);
    }
    this.props.dispatch(MsgBarActions.dismissMessage());
  };

  onClickSubmit = () => (
    this.props.dispatch(stopAsyncValidation('createaccountform', { clear: true }))
  );

  showTouModal = (event) => {
    const { dispatch, patient, authorizedRepData } = this.props;
    const isArSignUp = authorizedRepData && authorizedRepData.email;
    const homeFacilityId = isArSignUp ? authorizedRepData.facilityHomeId : patient.homeFacilityId;
    dispatch(loadTermsOfUse(homeFacilityId, this.props.languageCode));
    event.preventDefault();
    this.setState({ showModal: true });
  }

  closeModal = () => {
    this.setState({ showModal: !this.state.showModal });
  }

  createPasswordMessage(fieldsMeta) {
    const { minLength, capitalLetters, numbers, specialCharacters } = fieldsMeta;
    const { formatMessage } = this.props.intl;
    const description = formatMessage(messages.password.description);
    const minLengthText = formatMessage(messages.password.minLength, { minLength });
    const capitalLettersText = formatMessage(messages.password.capitalLetters, { capitalLetters });
    const numbersText = formatMessage(messages.password.numbers, { numbers });
    const specialCharactersText = formatMessage(messages.password.specialCharacters, { specialCharacters });
    let delimitedList = '';
    if (minLength > 0) {
      delimitedList += minLengthText;
    }
    if (capitalLetters > 0) {
      delimitedList += capitalLettersText;
    }
    if (numbers > 0) {
      delimitedList += numbersText;
    }
    if (specialCharacters > 0) {
      delimitedList += specialCharactersText;
    }
    const passwordRulesFormat = formatMessage(messages.password.format, { description, delimitedList });
    return (
      <div id="hlp_password">
        {passwordRulesFormat}
      </div>);
  }

  buildGetTermsOfUseStatement() {
    const { formatMessage } = this.props.intl;
    const text = formatMessage(messages.checkbox.tou);
    const link = (
      <a className="underline" data-toggle="modal" data-target="#TermsOfUse"
        onClick={this.showTouModal} role="link" tabIndex="0" aria-label="Terms of Use opens a new dialogue"
      >
        {text}
      </a>
    );
    const statement = formatMessage(messages.checkbox.accept, { link });
    return (
      <span key="key-tou-link">
        &nbsp;{statement}
      </span>
    );
  }

  renderTouCheckbox(checkboxAccept) {
    let checkBox = null;
    if (checkboxAccept.meta.error) {
      checkBox = (<input type="checkbox" id="checkboxAccept"
        value={checkboxAccept.input.value}
        onChange={checkboxAccept.input.onChange} aria-describedby="touError"
      />);
    } else {
      checkBox = (<input type="checkbox" id="checkboxAccept"
        value={checkboxAccept.input.value}
        onChange={checkboxAccept.input.onChange}
      />);
    }
    return checkBox;
  }

  renderFields = (fieldsMeta) => {
    const { email, username, password, confirmPassword, checkboxAccept, authorizedRepData } = fieldsMeta;
    const isArSignUp = authorizedRepData && authorizedRepData.email;
    const inputClasses = classNames({
      tou: true,
      checkbox: true,
    });
    return (
      <div>
        {!!isArSignUp ||
        <div className="row mb-3">
          <InputBlock
            id="email" labelText={ <FormattedMessage { ...messages.form.email } /> }
            type="text" field={email}
            help={ <FormattedMessage { ...messages.form.emailHelp } /> }
            toolTip="emailTooltip"
            onChange={this.onEmailChange(email, username)}
            customMessage={<FormattedMessage { ...messages.error.email } />}
            lgSize={8}
          />
        </div>}
        <div className="row mb-3">
        <InputBlock
          id="username" labelText={ <FormattedMessage { ...messages.form.username } /> }
          type="text" field={ username }
          help={ <FormattedMessage { ...messages.form.usernameHelp } /> }
          toolTip="usernameTooltip"
          minValue={4}
          customMessage={<FormattedMessage { ...messages.error.username } />}
          lgSize={8}
        />
        </div>
        <div className="row mb-3">
        <InputBlock
          id="password" labelText={ <FormattedMessage { ...messages.form.password } /> }
          type="password"
          hintText={ this.createPasswordMessage(fieldsMeta) }
          field={ password }
          customMessage={<FormattedMessage { ...messages.error.password } />}
          lgSize={8}
        />
        </div>
        <div className="row mb-3">
        <InputBlock
          id="confirmPassword" labelText={ <FormattedMessage { ...messages.form.confirmPassword } /> }
          type="password"
          field={ confirmPassword }
          customMessage={<FormattedMessage { ...messages.error.confirmPassword } />}
          lgSize={8}
        />
        </div>
        <div>
          <div className={inputClasses + ' mb-3'}>
            <FormLabel>
              {this.renderTouCheckbox(checkboxAccept)}
              {this.buildGetTermsOfUseStatement()}
            </FormLabel>
          </div>
          {
            checkboxAccept.meta.error ?
              <div className="form-validation-error mb-2" id="touError" >
                <FormattedMessage { ...messages.error.tou } />
              </div>
              :
              null
          }
        </div>
      </div>
    );
  };


  render() {
    const { handleSubmit,
      minLength,
      capitalLetters,
      numbers,
      specialCharacters,
      authorizedRepData,
    } = this.props;

    return (
      <div>
        <LoadingIndicatorContainer loadingKey="CreateAccount">
          <form onSubmit={handleSubmit(this.onSubmit)} >
            <Fields
              names={fields}
              component={this.renderFields}
              minLength={minLength}
              capitalLetters={capitalLetters}
              numbers={numbers}
              specialCharacters={specialCharacters}
              authorizedRepData={authorizedRepData}
            />
            <TouModal touContent={this.props.touContent}
              show={ this.state.showModal }
              onHide={ this.closeModal }
            />
            <button
              type="submit"
              data-qa-item="create-my-account"
              data-toggle="modal"
              data-target="#createmyaccount"
              className="btn btn-primary"
              href="signup2.html"
              aria-describedby="submitButtonDescription"
              onClick={this.onClickSubmit}
            >
              <FormattedMessage { ...messages.button.createAccount } />
            </button>
            &nbsp;
            <button
              data-qa-item="cancel_signup_step1"
              data-toggle="modal"
              data-target="#confirmCancel"
              className="btn btn-link"
              onClick={this.onClickCancel}
              aria-describedby="cancelButtonDescription"
            >
              <FormattedMessage { ...messages.button.cancel } />
            </button>
          </form>
          <span hidden id="cancelButtonDescription">
            <FormattedMessage { ...sharedMessages.labels.openNewDialog} />
          </span>
          <span hidden id="submitButtonDescription">
            <FormattedMessage { ...sharedMessages.labels.openNewScreen} />
          </span>
        </LoadingIndicatorContainer>
      </div>
    );
  }
}

CreateAccountForm.propTypes = {
  facilityId: PropTypes.string,
  dispatch: PropTypes.func,
  handleSubmit: PropTypes.func,
  touContent: PropTypes.string,
  patient: PropTypes.object,
  minLength: PropTypes.number,
  capitalLetters: PropTypes.number,
  numbers: PropTypes.number,
  specialCharacters: PropTypes.number,
  isTermsOfUseAccepted: PropTypes.bool,
  verifiedIdentityData: PropTypes.object,
  authorizedRepData: PropTypes.object,
  languageCode: PropTypes.string,
  intl: PropTypes.object,
};

const formConfig = {
  form: 'createaccountform',
  returnRejectedSubmitPromise: true,
  onSubmitFail: (errors) => scrollToFirstError(errors, fields),
};

const mapStateToProps = (state) => {
  let typedMinLength = 0;
  let typedCapitalLetters = 0;
  let typedNumbers = 0;
  let typedSpecialCharacters = 0;
  if (state.signUp.password) {
    typedMinLength = state.signUp.password.minLength;
    typedCapitalLetters = state.signUp.password.capitalLetters;
    typedNumbers = state.signUp.password.numbers;
    typedSpecialCharacters = state.signUp.password.specialCharacters;
  }
  return {
    patient: state.profile.patient,
    touContent: state.profile.user.termsOfUse,
    facilityId: state.facility.facilityId,
    minLength: typedMinLength,
    capitalLetters: typedCapitalLetters,
    numbers: typedNumbers,
    specialCharacters: typedSpecialCharacters,
    isTermsOfUseAccepted: state.signUp.isTermsOfUseAccepted,
    verifiedIdentityData: state.signUp.verifiedIdentityData,
    authorizedRepData: state.signUp.authorizedRepData,
    languageCode: state.language.languageCode,
  };
};

export default reduxForm(formConfig)(connect(mapStateToProps)(injectIntl(CreateAccountForm)));
